import {LOAD_STREAM, STOP_STREAM} from '../Stream';

export const fetchStream = data => ({type: LOAD_STREAM, data});
export const stopFetchStream = () => ({type: STOP_STREAM});



// WEBPACK FOOTER //
// ./js/actions/creators/Stream.js